import { render, staticRenderFns } from "./T1AsideTabNav.vue?vue&type=template&id=4fa96c07&scoped=true&"
import script from "./T1AsideTabNav.vue?vue&type=script&lang=js&"
export * from "./T1AsideTabNav.vue?vue&type=script&lang=js&"
import style0 from "./T1AsideTabNav.vue?vue&type=style&index=0&id=4fa96c07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa96c07",
  null
  
)

export default component.exports